export default {"src":"/_next/static/media/outrunService.7bf7b24d.svg","height":539,"width":593};